import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectResult } from 'services/results/selectors';

// Components
import RoleTable from 'components/RoleTable';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
// @ts-ignore
import NoSearchResults from 'components/NoSearchResults';
// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';

// Child Components
import DocumentSetsTableHead from './components/DocumentSetsTableHead';
import DocumentSetsTableRow from './components/DocumentSetsTableRow';

interface ConnectedProps {
    ids?: number[];
}

type Props = ConnectedProps;

export class DocumentSetsTable extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { ids } = this.props;
        if (!ids || !ids.length) {
            return <NoSearchResults />;
        }
        return (
            <ResponsiveTable>
                <RoleTable requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                    <DocumentSetsTableHead />
                    <Table.Body>
                        {ids.map(id => (
                            <DocumentSetsTableRow key={id} documentSetId={id} />
                        ))}
                    </Table.Body>
                </RoleTable>
            </ResponsiveTable>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    ids: makeSelectResult('documentSets')
});

export default connect(mapStateToProps)(DocumentSetsTable);
